import {authHttpClient, serverErrorToErrorList} from "../../utils/httpClient";
import {FETCH_CITY_LIST, SET_SERVER_ERROR} from "../actionTypes";

export const fetchCityList = (query = {}) => async (dispatch) => {
    try {
        let response = await authHttpClient.get(`/cities`);

        dispatch({
            type: FETCH_CITY_LIST,
            payload: response.data.data
        });

        return response.data;
    } catch (e) {
        dispatch({
            type: SET_SERVER_ERROR,
            payload: {errors: serverErrorToErrorList(e)}
        });
        throw e;

    }
};